module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 14.4 12.3\" enable-background=\"new 0 0 14.4 12.3\" xml:space=\"preserve\" title=\"Close\"><polygon points=\"14.4,0 12.3,0 7.2,5.1 2.1,0 0,0 6.2,6.2 0,12.3 2.1,12.3 7.2,7.2 12.3,12.3 14.4,12.3 8.3,6.2 \"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/icons/close.svg
// module id = 889
// module chunks = asvp